import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { settingSMS } from 'services/setting'
import posthog from 'posthog-js'

export default function useSetSms(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISettingSMSPayload) => {
            return settingSMS(payload)
        },
        onSuccess: (data, variables) => {
            const { moneyPool, ...toggles } = variables
            posthog.capture('fund_setting_notifications_saved', {
                fund_id: moneyPool,
                ...toggles,
            })
            refetch()
            toast.success('تغییرات با موفقیت انجام شد')
        },
        onError: (error: any, variables) => {
            posthog.capture('fund_setting_save_failed', {
                section: 'notifications',
                fund_id: variables?.moneyPool,
                status: error?.response?.status,
            })
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutate }
}
